import _classCallCheck from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/mnt/sdb/frontend/ibus/app/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from 'react';
import { Checkbox, createStyles, FormControlLabel, FormHelperText, withStyles } from '@material-ui/core';
import { checkRequired } from './utils';

var styles = function styles() {
  return createStyles({});
};

var CustomCheckbox =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CustomCheckbox, _React$Component);

  function CustomCheckbox() {
    _classCallCheck(this, CustomCheckbox);

    return _possibleConstructorReturn(this, _getPrototypeOf(CustomCheckbox).apply(this, arguments));
  }

  _createClass(CustomCheckbox, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          handler = _this$props.handler,
          meta = _this$props.meta,
          hasError = _this$props.hasError,
          touched = _this$props.touched,
          status = _this$props.status,
          value = _this$props.value;
      var isDisabled = status === 'DISABLED';
      var isRequired = checkRequired(this.props);
      return React.createElement(React.Fragment, null, React.createElement(FormControlLabel, {
        control: React.createElement(Checkbox, Object.assign({}, handler(), {
          color: 'primary',
          required: isRequired,
          disabled: isDisabled,
          checked: value
        })),
        label: meta.label
      }), touched && hasError('required') && React.createElement(FormHelperText, {
        error: true
      }, "\u041F\u043E\u043B\u0435 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043B\u044F \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F"));
    }
  }]);

  return CustomCheckbox;
}(React.Component);

export default withStyles(styles, {
  name: 'CustomCheckbox'
})(CustomCheckbox);